import { stringify } from 'qs';
import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';
import { async } from 'q';



export async function processTask(payload){
    return request(`/iwms-wms/wms/processTask?dcUuid=${loginOrg().uuid}`,{
        method:'POST',
        body: payload,
    })
}

export async  function finish(payload){
    return request(`/iwms-wms/wms/processTask/finish?uuid=${payload.uuid}&version=${payload.version}`,{
        method:'POST'
    })
}

export async function page(payload){
    return request(`/iwms-wms/wms/processTask/page`,{
        method: 'POST',
        body: payload,
    })
}
